import React from 'react';
import { useQuill } from "react-quilljs";

//styles
import 'quill/dist/quill.snow.css';

const RichTextEditor = (props) => {
  
  const {initialValue, setNewText} = props;

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
  
      [{ list: 'ordered'}, { list: 'bullet' }],
  
      ['link'],
    ],
    clipboard: {
      matchVisual: false,
    },
  }
  const { quill, quillRef } = useQuill({ modules });
  
  React.useEffect(() => {
    if (quill) {
      quill.on('text-change', (e) => {
        let newText = quill.getText().trim().length === 0 ? '' : quill.root.innerHTML
        setNewText(newText)
      });
    }
  }, [quill]);

  React.useEffect(() => {
    if (quill) {
      if(initialValue !== undefined)
        quill.clipboard.dangerouslyPasteHTML(initialValue);
    }
  }, [quill]);

  return (
    <div ref={quillRef} />
  );
};

export default RichTextEditor;
